import { useQuery } from '@tanstack/react-query';
import { DiscoveryResponse } from '@hud/portal-dtos/webapp-overview.dto';
import { useClient } from '../useClient';
import { PORTAL_BASE } from '../../consts';
import { TimeFrame } from '@hud/portal-dtos/webapp-common.dto';

export const QUERY_KEY = 'OverviewDiscovery';

type OverviewDiscoveryParams = {
  environmentName: string;
  timeFrame: TimeFrame;
  serviceIds?: number[];
};

export default function useOverviewDiscovery(
  overviewDiscoveryParams: OverviewDiscoveryParams,
) {
  const { client, isReady } = useClient();
  const { environmentName, timeFrame, serviceIds } = overviewDiscoveryParams;
  const params = {
    environmentName,
    timeFrame,
    serviceIds,
  };

  return useQuery({
    queryKey: [QUERY_KEY, environmentName, timeFrame, serviceIds],
    queryFn: async () => {
      const response = await client.get<DiscoveryResponse>(
        `${PORTAL_BASE}/overview/discovery`,
        { params },
      );
      return DiscoveryResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
